(() => {
  function initSlider(section) {
    const viewport = section.querySelector(
      '.preview-slider__viewport:not([data-auto-scroll])'
    );
    if (!viewport || viewport.dataset.initialized) return;
    viewport.dataset.initialized = 'true';

    // viewport ドラッグスクロール
    let vpDragging = false;
    let vpMoved = false;
    let vpStartX = 0;
    let vpStartScroll = 0;

    viewport.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      vpDragging = true;
      vpMoved = false;
      vpStartX = e.clientX;
      vpStartScroll = viewport.scrollLeft;
      viewport.setPointerCapture(e.pointerId);
      viewport.style.cursor = 'grabbing';
      e.preventDefault();
    });

    viewport.addEventListener('pointermove', (e) => {
      if (!vpDragging) return;
      vpMoved = true;
      viewport.scrollLeft = vpStartScroll - (e.clientX - vpStartX);
    });

    function endDrag() {
      vpDragging = false;
      viewport.style.cursor = '';
      setTimeout(() => {
        vpMoved = false;
      }, 0);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);

    // ドラッグ後のリンククリック防止
    viewport.addEventListener(
      'click',
      (e) => {
        if (vpMoved) {
          e.preventDefault();
        }
      },
      true
    );
  }

  // 初期化
  document.querySelectorAll('.preview-slider').forEach(initSlider);

  // Shopify テーマエディタ対応
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.preview-slider');
      if (section) initSlider(section);
    });
  }
})();
